import _ from 'lodash';
import moment from 'moment-timezone';
import { TZ } from '../../../../shared/consts';
import { INPUT_FMT } from '../../common/constants';

const countByType = events => _(events)
  .groupBy('it')
  .mapValues(arr => _.sumBy(arr, 'count'))
  .value();

const splitter = cutoff => ({ date }) => moment
  .tz(date, INPUT_FMT, TZ)
  // This works with an Infinity initialized cutoff date.
  .isSameOrBefore(cutoff, 'days');

const hashifyTypes = arr => _.reduce(arr, (r, { id }) => _.set(r, id, 0), {});

const merge = (types, currentHash, prevHash) => {
  const total = _.reduce(currentHash, (res, v) => res + v, 0);
  const prevTotal = _.reduce(prevHash, (res, v) => res + v, 0);
  const typesHash = hashifyTypes(types);
  return _.mapValues(typesHash, (zero, type) => {
    const count = currentHash[type] || 0;
    const prevCount = prevHash[type] || 0;
    const name = _.get(_.find(types, { id: parseInt(type, 10) }), 'name');
    const pct = total ? Math.round(100 * count / total) : 0;
    const prevPct = prevTotal ? Math.round(100 * prevCount / prevTotal) : 0;
    return {
      type: name,
      count,
      diff: pct - prevPct,
      pct,
    };
  });
};

export default function getTypes(events, daysAgo, types) {
  const cutoff = moment.tz(TZ).startOf('day').subtract(daysAgo - 1, 'days');
  const current = [...events];
  // This mutates `current`.
  const prev = _.remove(current, splitter(cutoff));
  const prevTypes = countByType(prev);
  const currentTypes = countByType(current);

  return _(merge(types, currentTypes, prevTypes))
    .map(v => v)
    .sortBy('type')
    .value();
}
